import { callGTMEvent } from './datalayer';
//MENU
$(document).ready(function() {
    //SCROLL DOWN FUNCTION
    $('a.btn-scroll[href*=\\#]:not([href=\\#])').on('click', function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - $(this).attr('data-offset')
                }, 500);
                return false;
            }
        }
    });

    //ADD CLASS TO HEADER
    $('.header-page').addClass('active');

    //Current Year
    var CurrentYear = new Date().getFullYear();
    $('.current-year').text(CurrentYear);

    // login
    $(window).on('load', function() {
        if (typeof page_ajax['im_Sign_Up_Login'] !== 'undefined') {
            var signUpLoginAction = page_ajax['im_Sign_Up_Login'];
            var signUpLoginData = page_ajax['im_Sign_Up_Login_Data'];
            if (signUpLoginAction && signUpLoginData) {
                callGTMEvent(signUpLoginAction, JSON.parse(signUpLoginData));
            }
            page_ajax['im_Sign_Up_Login'] = '';
            page_ajax['im_Sign_Up_Login_Data'] = '';
        }
    });

    /**
    * General Pages Login Integration
    */
    if (typeof page_ajax['im_Sign_Up_Login'] !== 'undefined') {
        var timestamp = (new Date()).getTime();
        document.cookie = "wp_user_logged_in=1;path=/";
        document.cookie = "expirycookie="+timestamp+";  path=/";
    }

    let isUserLoggedIn = getCookie('wp_user_logged_in');

    if(isUserLoggedIn){

        if( typeof(isLoggedVars) !== 'undefined'){
            window.localStorage.setItem("userData", JSON.stringify(isLoggedVars));
        }

        let auth = JSON.parse(window.localStorage.getItem("userData"));

        $.ajax({
            method: 'POST',
            url: `${auth.root}my-plugin/v1/islogged`,
            data: { _wpnonce: auth.nonce },
            dataType: 'json',
            success: function ( data ) {
                var User = {...data};

                if(User.isLogged == true){
                            
                    $('.user-logged').removeClass('d-none');
                    $('#topbar-username').html(`${User.username}`);
                    $('button#im-logout').on('click', function(){
                        callGTMEvent('im_logOut')
                        .then(() => {
                            window.location.href = User.logoutURL.replace('&amp;','&');
                            window.localStorage.removeItem("userData");
                            });
                        });
                    if(User.prefs){
                        document.cookie = `user_articles=${User.prefs.articles};path=/`;
                    } 
                }
            },
        })
    }
    else{
        $('.login-btn').removeClass('d-none');
        $('#section-login-component').removeClass('d-none');
        window.localStorage.removeItem("userData");
    }
        
})

//function to get cookie by name
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
// expire cookie after set time
var interval = setInterval(function(){
    var dayToExpire = 2;
    var timeStamp = getCookie('expirycookie') 
    if(!timeStamp){clearInterval(interval); return}
    var cookieDuration = dayToExpire*1440*60*1000 //expire cookie after 2 days, 1440 minutes in 1 day, duration in miliseconds
    if(timeStamp < (new Date()).getTime() - cookieDuration){
      //cookie expired delete here
      document.cookie = 'wp_user_logged_in=1; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = 'user_articles=value; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = 'expirycookie=value; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
     clearInterval(interval)
   }
 },1000)